import { StoreonModule } from 'storeon';
import { IEvents, IState } from 'src/store';
import { ICity } from 'src/api';

interface AppStoreModule {
  loading: boolean;
  priceList: any[];
  variables: { [key: string]: string };
  cities: ICity[];
}

export interface IAppState {
  appStore: AppStoreModule;
}

export interface IAppEvents {
  'app/init': undefined;
  'app/set-loading': { isLoading: boolean };
  'app/set-price-list': { priceList: any[] };
  'app/set-variables': { variables: { [key: string]: string } };
  'app/set-cities': { cities: ICity[] };
}

const initialState: AppStoreModule = {
  loading: false,
  priceList: [],
  variables: {},
  cities: [],
};

export const appStoreModule: StoreonModule<IState, IEvents> = (store) => {
  store.on('@init', () => ({
    appStore: { ...initialState },
  }));

  store.on('app/set-price-list', (state, payload) => ({
    appStore: { ...state.appStore, priceList: payload.priceList },
  }));
  store.on('app/set-loading', (state, payload) => ({
    appStore: { ...state.appStore, loading: payload.isLoading },
  }));
  store.on('app/set-variables', (state, payload) => ({
    appStore: { ...state.appStore, variables: payload.variables },
  }));
  store.on('app/set-cities', (state, payload) => ({
    appStore: { ...state.appStore, cities: payload.cities },
  }));
};
